var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshareFill = function SvgScreenshareFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#screenshare-fill_svg__a)",
    fill: "#FF5C7F"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff5c7f"
    },
    y: 17.474,
    width: 24,
    height: 1.895,
    rx: 0.947
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    d: "M20.929 16a2.22 2.22 0 0 0 2.214-2.214V2.714A2.22 2.22 0 0 0 20.929.5H3.214A2.22 2.22 0 0 0 1 2.714v11.072C1 15.004 1.985 16 3.214 16H20.93c.609 0-.8 0 0 0 .553 0-.554 0 0 0Zm-7.75-3.908V9.667c-3.078 0-5.104.941-6.643 3.012.62-2.957 2.336-5.902 6.643-6.5V3.822l3.996 3.72a.555.555 0 0 1 0 .809l-3.996 3.742Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "screenshare-fill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v20H0z"
  })))));
};
export default SvgScreenshareFill;